export enum WidgetAction {
  PIN = 'PIN_WIDGET',
  COLLAPSE = 'COLLAPSE_WIDGET'
}
